export const IntegrationsReducerInitialState = {
  integrationsByType: {},
  integrationAccountsById: {},
  integrationAccountsByType: {},
  loadingIntegrations: false,
  loadingAccounts: false,
};
